import Toast from "bootstrap/js/dist/toast";
import { Target, Value } from "@vytant/stimulus-decorators";
import ApplicationController from "./application_controller";

export default class ToastController extends ApplicationController {
  @Target noticeTemplateTarget!: HTMLTemplateElement;
  @Target noticeContentTarget!: HTMLElement;
  @Target alertTemplateTarget!: HTMLTemplateElement;
  @Target alertContentTarget!: HTMLElement;
  @Target containerTarget!: HTMLElement;
  @Value(String) noticeValue!: string;
  @Value(String) alertValue!: string;
  // TWMIGRATE: The hideClassValue is used to trigger the Tailwind version of the toast.
  // It can be removed when we finish moving all styles to Tailwind, along with all the temporary conditionals.
  @Value(String) hideClassValue!: string;

  activeToast?: Toast;
  activeToastElement?: Element;

  connect() {
    if (this.noticeValue.length) {
      this.notice(this.noticeValue);
    }
    if (this.alertValue.length) {
      this.alert(this.alertValue);
    }
  }

  insertNotice(event: StimulusEvent) {
    this.notice(event.detail.html);
  }

  notice(message: string) {
    this.containerTarget.innerHTML = this.noticeTemplateTarget.innerHTML;
    this.noticeContentTarget.innerHTML = message;
    const toastElement = this.containerTarget.firstElementChild;
    if (toastElement) {
      const toast = Toast.getOrCreateInstance(toastElement, {
        autohide: true,
        delay: 4000,
        animation: false,
      });
      // TWMIGRATE: Temporary conditional to work with Bootstrap and Tailwind
      if (this.hideClassValue) {
        toastElement.classList.remove(this.hideClassValue);
        setTimeout(() => this.hide(), 4000);
      } else {
        toast.show();
      }
      this.activeToast = toast;
      this.activeToastElement = toastElement;
    }
  }

  insertAlert(event: StimulusEvent) {
    this.alert(event.detail.html);
  }

  alert(message: string) {
    this.containerTarget.innerHTML = this.alertTemplateTarget.innerHTML;
    this.alertContentTarget.innerHTML = message;
    const toastElement = this.containerTarget.firstElementChild;
    if (toastElement) {
      const toast = Toast.getOrCreateInstance(toastElement, {
        autohide: false,
        animation: false,
      });
      // TWMIGRATE: Temporary conditional to work with Bootstrap and Tailwind
      if (this.hideClassValue) {
        toastElement.classList.remove(this.hideClassValue);
      } else {
        toast.show();
      }
      this.activeToast = toast;
      this.activeToastElement = toastElement;
    }
  }

  hide() {
    // TWMIGRATE: Temporary conditional to work with Bootstrap and Tailwind
    if (this.hideClassValue) {
      this.activeToastElement?.classList?.add(this.hideClassValue);
    } else {
      this.activeToast?.hide();
    }
  }
}
